import { defaultHttpClient } from '../../httpClient';
import type { GetOverviewCategoriesResponse } from './types';

export const getOverviewCategories = () => {
  return defaultHttpClient
    .request<GetOverviewCategoriesResponse>({
      method: 'GET',
      url: '/api/v2/overview/category-index-list',
    })
    .then(result => result.data);
};
